module.exports = __webpack_public_path__ + "img/SendComment.bca155c0.svg";